import { render, staticRenderFns } from "./photoDrugAudit.vue?vue&type=template&id=f63d3270&scoped=true&"
import script from "./photoDrugAudit.vue?vue&type=script&lang=js&"
export * from "./photoDrugAudit.vue?vue&type=script&lang=js&"
import style0 from "./photoDrugAudit.vue?vue&type=style&index=0&id=f63d3270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63d3270",
  null
  
)

export default component.exports